<div class="control-numbers-alert" role="status" *ngIf="visible">
    <span class="control-numbers-alert__icon">
        <i-feather name="alert-triangle" aria-hidden="true"></i-feather>
    </span>
    <span class="control-numbers-alert__message" *ngIf="canRequest; else askAdmin">{{ remainingLabel }} Solicita {{ status.package.quantity | number }} gratis en Mejora tu Fina.</span>
    <ng-template #askAdmin>
        <span class="control-numbers-alert__message">{{ remainingLabel }} Pídele al dueño del comercio que los solicite en Mejora tu Fina.</span>
    </ng-template>
    <a *ngIf="canRequest" class="btn control-numbers-alert__action" routerLink="/comercio/mejora-tu-fina">Ir a Mejora tu Fina</a>
</div>
